import { useForm } from 'libs/form'
import type { FieldValues } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import { BackButton, Form, Header } from 'shared/components'
import { DEFAULT_COLOR } from 'features/areaTypes/areaTypes.config'
import { useAreaTypeValidationSchema } from 'features/areaTypes/hooks/useAreaTypeValidationSchema'
import { AreaTypeFormSections } from 'features/areaTypes/organisms/AreaTypeForm/AreaTypeFormSections'
import { toAreaTypeFormData } from 'features/areaTypes/utils/toAreaTypeFormData'
import { useCreateAreaType } from './mutations/useCreateAreaType'

const AreaTypeAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useAreaTypeValidationSchema()

	const form = useForm<FieldValues>({
		mode: 'onChange',
		resolver: validationResolver,
		defaultValues: {
			availability_algorithm: 'any_available',
			primary_color: DEFAULT_COLOR,
			secondary_color: DEFAULT_COLOR,
			image: null
		}
	})
	const { handleSubmit } = form

	const { createAreaType, isCreateAreaTypeLoading } = useCreateAreaType()

	return (
		<>
			<Header
				title={t('Add area type')}
				eyebrow={t('Booking engine')}
				actions={<BackButton to={routes.areaTypeIndex} text={t('Back to area types')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Create area type')}
					onSubmit={handleSubmit((data) => createAreaType(toAreaTypeFormData(data, !!data.image)))}
					isLoading={isCreateAreaTypeLoading}>
					<AreaTypeFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default AreaTypeAddPage
